import { Document } from "~/document";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import paths from "~/paths";
import languageStore from "~/stores/language";
import { TranslationInfo } from "~/document";
import { useMemo } from "react";

interface Props {
  document: Document;
  translations: TranslationInfo[];
}

const LanguageDisplay = observer((props: Props) => {
  const { document } = props;
  const translations = useMemo(() => [...props.translations, document], [props.translations, document]);
  const langIdToLangInfo = languageStore.loadedLanguages;
  if (!document.language && translations.length === 0) {
    return <div>No languages available</div>;
  }
  if (languageStore.loading) {
    return null;
  }

  const docLanguageDisplay = langIdToLangInfo[document.language]?.text ?? "";
  const areThereAnyLanguagesAvailable = docLanguageDisplay || translations.length !== 0;
  if (!areThereAnyLanguagesAvailable) {
    return <div>No languages available</div>;
  }
  return (
    <div>
      {translations.map((tr) => (
        <Link
          key={tr.language}
          className="mr-1.5 inline-block no-underline last:mr-0 hover:underline"
          to={paths.construct.docDetail(tr.protocol)}
        >
          {langIdToLangInfo[tr.language]?.text ?? tr.language}
        </Link>
      ))}
    </div>
  );
});

export default LanguageDisplay;
